export const aboutData = {
    title: "About me",
    description1: "Hello! My name is Swapnil Kapadnis and I enjoy creating things that live on the internet.",
    description2: "I'm a passionate Developer, with strong administrative and communication skills, good attention to detail and the ability to write efficient code using MERN Stack.As I grow and flourish as a Developer, one thing which keeps me going is my inquisitiveness for discovering new things every day.",
    image: 2
}